import {
	CreditLineState,
	CreditLineStateNotPaidDueLessThan7DaysTypeEnum,
	CreditLineStateNotPaidDueMissedTypeEnum,
	CreditLineStateNotPaidDueMoreThan7DaysTypeEnum,
	CreditLineStateNotPaidDueTodayTypeEnum,
	CreditLineStateNotPaidDueTomorrowTypeEnum,
	Money,
} from '../../../types/generated/pos';

export const getCreditMinPayment = (
	creditState: CreditLineState
): Money | undefined => {
	const { type } = creditState;

	switch (type) {
		case CreditLineStateNotPaidDueMoreThan7DaysTypeEnum.NotPaidDueMoreThan7Days:
		case CreditLineStateNotPaidDueLessThan7DaysTypeEnum.NotPaidDueLessThan7Days:
		case CreditLineStateNotPaidDueMissedTypeEnum.NotPaidDueMissed:
		case CreditLineStateNotPaidDueTodayTypeEnum.NotPaidDueToday:
		case CreditLineStateNotPaidDueTomorrowTypeEnum.NotPaidDueTomorrow:
			return creditState.minPayment;
		default:
			return undefined;
	}
};
